import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Este proyecto no tiene valores de respaldo a propósito: si falta una variable,
// nunca debe conectarse por accidente al Firebase de otra empresa.
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID
};

const missingFirebaseVariables = Object.entries(firebaseConfig)
  .filter(([, value]) => !value || value.startsWith('REEMPLAZAR_'))
  .map(([key]) => key);

const isFirebaseConfigured = missingFirebaseVariables.length === 0;

let app = null;
let auth = null;
let db = null;
let storage = null;

if (isFirebaseConfigured) {
  app = initializeApp(firebaseConfig);
  auth = getAuth(app);
  db = getFirestore(app);
  storage = getStorage(app);
}

export {
  app,
  auth,
  db,
  storage,
  isFirebaseConfigured,
  missingFirebaseVariables
};
